export default __webpack_public_path__ + "static/media/icon_hallinto_aloitettu.a9eec744.svg";